import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import AddLeadLayer  from '../components/leads/AddLeadLayer'

export const AddLeadPage = () => {
  return (
    <MasterLayout>
        <AddLeadLayer/>
    </MasterLayout>
  )
}
